import type { ColumnsType } from "antd/es/table";
import { IAuthDetailTableData } from "@/pages/authorization-management/components/auth-detail-table/hooks/useAuthDetailTable";
import { AuthDetailTableCheckbox } from "@/pages/authorization-management/components/auth-detail-table/components/auth-detail-table-checkbox";
import { IAuthDetailCheckboxInfo } from "@/pages/authorization-management/components/auth-detail-table/hooks/useAuthDetailTable";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
const t = getTranslateNsT("center");
const permissionT = getTranslateNsT("permission");
export const tableColumns: ColumnsType<IAuthDetailTableData> = [
  {
    key: "module",
    title: t("user_auth_model"),
    width: 120,
    align: "center",
    render: (row) => permissionT(`admin_${row.moduleAuthority}`),
  },
  {
    key: "authObject",
    title: t("user_auth_object"),
    width: 160,
    render: (row) => <AuthDetailTableCheckbox {...row.authObject} />,
  },
  {
    key: "permissions",
    title: t("user_auth_permission"),
    width: 565,
    render: (row) =>
      row.permissions.map((item: IAuthDetailCheckboxInfo) => (
        <AuthDetailTableCheckbox key={item.authority} {...item} />
      )),
  },
];
